export const INTEGERS_UNIT = /^[0-9]+$/;
export const FILE_EXTENSION = /\.([0-9a-z]+)(?:[?#]|$)/i;
